export default __webpack_public_path__ + "static/media/11.908c7c17.jpg";